import EditPageContainer from '@app/components/EditPageContainer'
import { Property } from '@app/models/Property'
import {
  ITransactionHistory,
  TransactionHistory,
} from '@app/models/TransactionHistory'
import { ICurrentUserState } from '@app/store/modules/account'
import {
  IGlobalCompaniesState,
  IGlobalCompanyContactsState,
  IGlobalConfigurationState,
  IGlobalSocialNetworksState,
} from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import * as qs from 'query-string'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import {
  actionCreators,
  IPropertyEditState,
} from '@app/components/PropertyEdit/modules/propertyEdit'
import './PropertyEditPage.scss'
import PropertyEdit from '@app/components/PropertyEdit'

interface IConnectionViewRouterProps {
  id: string
}

interface IComponentState {
  lotModalIsOpen: boolean
  showConfirmDelete: any
  showConfirmEdit: any
  spaceModalIsOpen: boolean
  transaction: ITransactionHistory
  transactionModalIsOpen: boolean
}

type IComponentProps = IPropertyEditState &
  ICurrentUserState &
  IGlobalCompanyContactsState &
  IGlobalCompaniesState &
  IGlobalConfigurationState &
  IGlobalSocialNetworksState &
  RouteComponentProps<IConnectionViewRouterProps> &
  typeof actionCreators

export default class PropertyEditPage extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  constructor(props: IComponentProps) {
    super(props)

    bindFunctions(this)

    this.state = {
      lotModalIsOpen: false,
      showConfirmDelete: {},
      showConfirmEdit: {},
      spaceModalIsOpen: false,
      transaction: new TransactionHistory(),
      transactionModalIsOpen: false,
    }
  }

  public render() {
    return (
      <EditPageContainer
        saveDisabled={this.props.isSaving}
        title={this.props.match.params.id ? 'Edit Property' : 'New Property'}
        onSaveClick={this._saveProperty}
        onCancelClick={this._cancel}
      >
        <PropertyEdit
          propertyId={this.props.match.params.id}
          siteId={qs.parse(this.props.location.search).site}
        />
      </EditPageContainer>
    )
  }

  private async _saveProperty() {
    this.props.save(this.props.property as Property)
  }

  private _cancel() {
    this.props.history.goBack()
  }
}
